// fullFaceBotoxData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    keywords?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: any;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
    relatedTreatments?: {
        en: string;
        ar: string;
        href: string;
        image: string;
    }[];
    treatments?: {
        heading?: string;
        subheading?: string;
        items: {
            en: string;
            ar: string;
            href: string;
        }[];
    };
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
        currency?: string | undefined;
        duration?: string,
        effectsLast: string,
        category: string
    };
}

export const hyperhidrosisBotox: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} = {
    "en": {
        "url": "",
        "meta": {
            "title": "Hyperhidrosis Treatment Dubai | Elite Body Home Polyclinic",
            "description": "Get expert hyperhidrosis treatment in Dubai to manage excessive sweating. Our advanced methods provide lasting relief and comfort. Book your consultation today!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/hyperhidrosis-botox/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Hyperhidrosis Treatment Dubai | Elite Body Home Polyclinic",
                "description": "Get expert hyperhidrosis treatment in Dubai to manage excessive sweating. Our advanced methods provide lasting relief and comfort. Book your consultation today!",
                "url": "https://elitebodyhome.com/hyperhidrosis-botox/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-13T15:38:54+00:00",
                "image": {
                    "url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg",
                    "secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg",
                    "width": 1254,
                    "height": 700,
                    "alt": "hyperhidrosis treatment",
                    "type": "image/jpeg"
                }
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Hyperhidrosis Treatment Dubai | Elite Body Home Polyclinic",
                "description": "Get expert hyperhidrosis treatment in Dubai to manage excessive sweating. Our advanced methods provide lasting relief and comfort. Book your consultation today!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Hyperhidrosis Botox"],
        "hero": {
            "title": "Hyperhidrosis Botox Treatment in Dubai",
            "subtitle": "",
            "description": "What is Hyperhidrosis Botox Treatment? Botox for hyperhidrosis involves using Botulinum toxin to block the nerves that cause excessive sweating. The procedure targets areas like the underarms, hands, feet, and face, where overactive sweat glands are causing discomfort."
        },
        "howItWorks": {
            "title": "Key Points:",
            "description": "Minimally invasive: Botox injections are a non-surgical solution to excessive sweating. Long-lasting effects: Results can last for several months, making it a preferred choice for many. FDA-approved: Botox is an approved and safe treatment option for primary axillary hyperhidrosis (excessive underarm sweating)."
        },

        "procedureSteps": {
            "heading": "Steps For Hyperhidrosis Treatment Procedure",
            "para": "The Botox therapy for hyperhidrosis is a simple and somewhat short procedure. When carried out by a qualified medical practitioner, the process guarantees that particular regions that are prone to excessive perspiration are adequately addressed.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "In order to evaluate the afflicted areas and make sure Botox is the best course of action for the patient, a consultation is held prior to the procedure.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Identifying the Region",
                    "desc": "The locations that will receive injections will be marked by the practitioner.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "Injections",
                    "desc": "In the regions with overactive sweat glands, Botox is injected just beneath the skin using a tiny needle.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Marking the Area",
                    "desc": "The practitioner will mark the areas where injections will be administered.",
                    "icon": "fa-solid fa-pen"
                },
                {
                    "title": "Aftercare",
                    "desc": "Patients can resume normal activities immediately after the treatment, with minimal restrictions.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Hyperhidrosis Botox",
            "subheading": "",
            "para": "Hyperhidrosis Botox offers a number of benefits, allowing individuals to regain confidence and comfort in their everyday lives. It is a trusted and efficient solution for those suffering from excessive sweating, particularly in areas like the underarms, palms, and soles of the feet.",
            "items": [
                {
                    "title": "Efficient management of perspiration",
                    "desc": "Depending on the area treated, Botox can reduce perspiration by as much as 82–87%.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Minimally invasive and rapid",
                    "desc": "Botox is a non-surgical procedure that offers relief with little to no downtime.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Durable outcomes",
                    "desc": "Most patients enjoy dryness for 6 to 12 months, reducing the need for daily antiperspirants or special treatments.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Enhanced self-assurance",
                    "desc": "Following therapy, patients frequently report feeling less self-conscious and more confident.",
                    "icon": "fa-solid fa-face-smile-beam"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Not everyone who sweats excessively has hyperhidrosis, and not everyone with hyperhidrosis is a candidate for Botox treatment. It’s important to undergo a thorough consultation to determine if Botox is the right treatment for you.",
            "items": [
                {
                    "title": "Individuals with Excessive Sweating",
                    "desc": "People who experience abnormal sweating (hyperhidrosis) that affects their daily activities, particularly in the underarms, hands, feet, or face.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "Patients Unresponsive to Other Treatments",
                    "desc": "Those who have tried other forms of treatment such as prescription antiperspirants, oral medications, or other topical treatments but haven’t seen significant improvement.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Medically Cleared Candidates",
                    "desc": "Patients who are in good overall health, with no history of neuromuscular diseases or allergies to botulinum toxin.",
                    "icon": "fa-solid fa-notes-medical"
                },
                {
                    "title": "People Seeking a Non-Surgical Solution",
                    "desc": "Individuals looking for a minimally invasive option to manage excessive sweating without the need for surgical intervention.",
                    "icon": "fa-solid fa-hands-holding"
                },
                {
                    "title": "Candidates Looking for Long-Lasting Results",
                    "desc": "Those seeking temporary relief from hyperhidrosis, typically lasting 4 to 6 months with regular Botox injections.",
                    "icon": "fa-solid fa-hourglass-half"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Preparing for Hyperhidrosis Botox treatment involves a few important steps to ensure the best possible outcome. Following the right pre-procedure guidelines will help the treatment be more effective and reduce the likelihood of side effects.",
            "items": [
                {
                    "title": "Do not shave the treated area",
                    "desc": "Do not shave the armpits for a minimum of 24 hours prior to the treatment.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Avoid antiperspirants and deodorants",
                    "desc": "Do not wear deodorants/antiperspirants on the day of treatment.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Talk to your doctor about drugs",
                    "desc": "Some medications (including blood thinners) can heighten the likelihood of bruising, so be sure to check in with your doctor if you’re on any medications.",
                    "icon": "fa-solid fa-capsules"
                },
                {
                    "title": "Wear loose clothing",
                    "desc": "It is recommended that you wear loose, comfortable clothing the day of the procedure, so there is no irritation after the treatment.",
                    "icon": "fa-solid fa-shirt"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Hyperhidrosis Botox provides lasting, dramatic relief for people who are suffering from excessive sweating. Surely that was not only a physical result, but the emotional change to that person’s life as a whole could change completely for the better.",
            "items": [
                {
                    "title": "Reduced sweating",
                    "desc": "You can expect a significant decrease in sweating in the treated areas (for 6-12 months).",
                    "icon": "fa-solid fa-tint-slash"
                },
                {
                    "title": "Quick onset of results",
                    "desc": "A lot of the patients see a decrease in their perspiration already in 2-4 days after being treated.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "Improved quality of life",
                    "desc": "Less sweating means less self-consciousness, which results in more social confidence, at work and at play.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "Minimal side effects",
                    "desc": "Although some degree of redness or bruising is possible, it is generally temporary and minimal.",
                    "icon": "fa-solid fa-circle-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Why Choose Elite Body Home for Hyperhidrosis Treatment?",
            "subheading": "",
            "para": "Select Elite Body Home for Hyperhidrosis Botox to receive professional treatment in a cutting-edge setting. Our highly skilled professionals provide individualized treatment programs to guarantee secure, efficient, and long-lasting outcomes. We offer the best service possible in a contemporary, friendly setting, all while putting your comfort and confidence first. Elite Body Home allows you to live a confident and sweat-free life.",
            "items": [
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does Hyperhidrosis Botox last?",
                    "answer": "Results can last between 4 to 6 months, after which a maintenance treatment is recommended."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most patients experience minimal discomfort, and a topical anesthetic can be used to enhance comfort."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Results usually appear within 2 to 7 days, with full results visible after 2 weeks."
                },
                {
                    "question": "Can I return to work after the treatment?",
                    "answer": "Yes, there’s no downtime required, and you can resume normal activities immediately after the procedure."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/botox-Hyperhidrosis-Botox-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Underarm-Botox-in-dubai-uae-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/botox-Hyperhidrosis-Botox-2.jpg"
            ]
        },
        "product": {
            "id": 2,
            "title": "Underarm Botox Treatment",
            "price": 299,
            "currency": "AED",
            "description": "Clinically proven Botox treatment for underarms to reduce excessive sweating (hyperhidrosis) and boost confidence.",
            "duration": "30-45 minutes",
            "effectsLast": "4-6 months",
            "category": "hyperhidrosis-treatment"
        },
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج فرط التعرق بالبوتوكس في دبي | عيادات ايليت بودي هوم",
            "description": "احصل على علاج فرط التعرق في دبي من الخبراء. نقدم طرقًا متقدمة لتوفير راحة دائمة من التعرق الزائد. احجز استشارتك اليوم!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/hyperhidrosis-botox/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "علاج فرط التعرق بالبوتوكس في دبي | عيادات ايليت بودي هوم",
                "description": "احصل على علاج فرط التعرق في دبي من الخبراء. نقدم طرقًا متقدمة لتوفير راحة دائمة من التعرق الزائد. احجز استشارتك اليوم!",
                "url": "https://elitebodyhome.com/hyperhidrosis-botox/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-13T15:38:54+00:00",
                "image": {
                    "url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg",
                    "secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg",
                    "width": 1254,
                    "height": 700,
                    "alt": "علاج فرط التعرق",
                    "type": "image/jpeg"
                }
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "علاج فرط التعرق بالبوتوكس في دبي | عيادات ايليت بودي هوم",
                "description": "احصل على علاج فرط التعرق في دبي من الخبراء. نقدم طرقًا متقدمة لتوفير راحة دائمة من التعرق الزائد. احجز استشارتك اليوم!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/2-2.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج فرط التعرق بالبوتوكس"],
        "hero": {
            "title": "علاج فرط التعرق بالبوتوكس في دبي",
            "subtitle": "",
            "description": "يُعتبر فرط التعرق مشكلة مزعجة تؤثر على الثقة بالنفس وتُعيق الحياة اليومية. يُعد البوتوكس علاجًا مثبتًا وفعالًا يمنحك راحة لمدة طويلة لعلاج فرط التعرق سواء كان في راحة اليدين، أو الإبطين، أو مناطق أخرى. نُقدم حقن البوتوكس المتخصصة لمساعدتك على استعادة السيطرة والشعور براحة أكبر مع بشرتك."
        },
        "howItWorks": {
            "title": "أهم المميزات:",
            "description": "إجراء غير جراحي: حقن البوتوكس هي طريقة آمنة ومريحة لعلاج التعرق الزائد دون الحاجة إلى جراحة. نتائج طويلة الأمد: يستمر تأثير العلاج لعدة أشهر، مما يجعله خيارًا مفضلاً للكثير. معتمد من إدارة الغذاء والدواء الأمريكية (FDA): يعتبر البوتوكس علاجًا آمنًا وفعالًا للتعرق المفرط في منطقة الإبطين."
        },
        "procedureSteps": {
            "heading": "خطوات علاج فرط التعرق بالبوتوكس",
            "para": "يُعد علاج فرط التعرق بالبوتوكس إجراء سريع وبسيط، يُجرى تحت إشراف طبيب مختص لضمان استهداف وعلاج المناطق الأكثر تعرّضًا للتعرق الزائد بفعالية.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تُجرى استشارة مبدئية لتقييم الحالة وتحديد مدى ملائمة البوتوكس كخيار علاجي للمريض.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "تحديد المنطقة المستهدفة",
                    "desc": "يحدد الطبيب الأماكن التي سيتم حقن البوتوكس بها لضمان الدقة في العلاج.",
                    "icon": "fa-solid fa-map-marker-alt"
                },
                {
                    "title": "حقن المنطقة المُستهدفة",
                    "desc": "تُستخدم إبرة دقيقة لحقن البوتوكس تحت سطح الجلد في المناطق التي تعاني من النشاط المفرط للغدد العرقية.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "العناية بعد العلاج",
                    "desc": "يمكن للمريض العودة إلى الأنشطة اليومية مباشرة بعد الجلسة، مع حد أدنى من القيود لضمان التعافي الأمثل.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "مميزات علاج فرط التعرق بوتوكس",
            "subheading": "",
            "para": "يوفر علاج فرط التعرق بالبوتوكس العديد من المزايا، مما يساعد الأفراد على استعادة ثقتهم وراحتهم في حياتهم اليومية، يُعد هذا العلاج خيارًا موثوقًا وفعالًا لمن يعاني من التعرق الزائد خاصة في الإبطين، وراحتي اليدين، وباطن القدمين.",
            "items": [
                {
                    "title": "تحكم فعال في التعرق",
                    "desc": "يخفف البوتوكس من التعرق بنسبة 82-87% حسب المنطقة المُعالجة.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "إجراء سريع وغير جراحي",
                    "desc": "يعتبر علاج غير جراحي يوفر راحة فورية، ولا يتطلب فترة تعافي.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "يستمتع معظم المرضى بجفاف يدوم من 6 إلى 12 شهرًا، مما يقلل الحاجة إلى مضادات التعرق اليومية أو العلاجات الأخرى.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يشعر المرضى براحة أكبر بعد العلاج، ويقل القلق من مشكلة التعرق الزائد.",
                    "icon": "fa-solid fa-face-smile-beam"
                }
            ]
        },
        "eligibility": {
            "heading": "معايير التأهل لعلاج فرط التعرق بالبوتوكس",
            "subheading": "",
            "para": "لا يُعد كل من يعاني من التعرق الزائد مصابًا بفرط التعرق، كما أن ليس كل من يعاني من فرط التعرق مؤهلًا لعلاج البوتوكس. لذا، من الضروري إجراء استشارة طبية شاملة لتحديد ما إذا كان البوتوكس هو الخيار المناسب لك.",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من الفرط التعرق",
                    "desc": "الأشخاص الذين يعانون من التعرق غير الطبيعي ويؤثر على أنشطتهم اليومية خاصةً في الإبطين، أو راحتي اليدين، أو باطن القدمين، أو الوجه.",
                    "icon": "fa-solid fa-temperature-high"
                },
                {
                    "title": "المرضى غير المستجيبين للعلاجات الأخرى",
                    "desc": "الأشخاص الذين جربوا مضادات التعرق الطبية، أو العلاجات الموضعية، أو الأدوية الفموية دون تحقيق نتائج مرضية.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الأشخاص الذين يتمتعون بصحة جيدة",
                    "desc": "المرشحون المثاليون هم من يتمتعون بصحة عامة جيدة، ولا يعانون من أمراض عصبية عضلية أو حساسية تجاه مادة توكسين البوتولينوم.",
                    "icon": "fa-solid fa-notes-medical"
                },
                {
                    "title": "الراغبون في حل غير جراحي",
                    "desc": "الباحثين عن خيار آمن وغير جراحي لعلاج فرط التعرق دون الحاجة إلى تدخلات جراحية.",
                    "icon": "fa-solid fa-hands-holding"
                },
                {
                    "title": "الراغبون في نتائج تدوم لفترة طويلة",
                    "desc": "المرضى الذين يسعون إلى تخفيف مؤقت لفرط التعرق، حيث تدوم نتائج حقن البوتوكس عادةً بين 4 إلى 6 أشهر مع الحاجة إلى جلسات منتظمة للحفاظ على النتائج.",
                    "icon": "fa-solid fa-hourglass-half"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يعد التحضير المناسب لعلاج فرط التعرق بالبوتوكس خطوة أساسية لضمان أفضل النتائج، حيث إن اتباع الإرشادات الصحيحة قبل الإجراء يساعد في تحقيق أقصى فاعلية للعلاج وتقليل الآثار الجانبية المُحتملة.",
            "items": [
                {
                    "title": "تجنب الحلاقة",
                    "desc": "يُفضل الامتناع عن حلاقة منطقة العلاج، خاصة تحت الإبط، لمدة لا تقل عن 24 ساعة قبل الإجراء.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "الامتناع عن استخدام مضادات التعرق ومزيلات رائحة العرق",
                    "desc": "لا تستخدم مضادات تعرق أو مزيلات رائحة العرق على المناطق المستهدفة بالعلاج في يوم الجلسة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "مراجعة الأدوية مع طبيبك",
                    "desc": "يجب استشارة الطبيب إذا كنت تتناول أدوية مثل مميعات الدم، حيث يمكن أن تزيد هذه الأدوية من احتمالية حدوث الكدمات بعد الحقن.",
                    "icon": "fa-solid fa-capsules"
                },
                {
                    "title": "ارتداء ملابس فضفاضة",
                    "desc": "يُفضل ارتداء ملابس مريحة وواسعة في يوم الإجراء لخفض تهيج الجلد بعد العلاج.",
                    "icon": "fa-solid fa-shirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر علاج فرط التعرق بالبوتوكس راحة لمدة طويلة للأشخاص الذين يعانون من التعرق الزائد، حيث لا تقتصر فوائده على تقليل التعرق فحسب، بل تسهم بشكل كبير في تعزيز الثقة بالنفس وتحسين جودة الحياة.",
            "items": [
                {
                    "title": "تقليل ملحوظ في التعرق",
                    "desc": "يساعد البوتوكس في تقليل التعرق في المناطق المعالجة بنسبة كبيرة ولمدة تتراوح بين 6 إلى 12 شهرًا.",
                    "icon": "fa-solid fa-tint-slash"
                },
                {
                    "title": "نتائج سريعة الظهور",
                    "desc": "يبدأ العديد من المرضى بملاحظة انخفاض التعرق خلال 2 إلى 4 أيام فقط بعد العلاج.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "تحسين جودة الحياة",
                    "desc": "يؤدي انخفاض التعرق إلى تقليل القلق الاجتماعي، مما يسمح للأشخاص بالشعور براحة وثقة أكبر في المواقف اليومية والمهنية.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "يمكن أن تظهر بعض الآثار الجانبية المؤقتة مثل احمرار خفيف أو كدمات بسيطة، لكنها تزول سريعًا دون أي مضاعفات خطيرة.",
                    "icon": "fa-solid fa-circle-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا يجب اختيار عيادات ايليت بودي هوم في دبي لعلاج فرط التعرق؟",
            "subheading": "",
            "para": "اختر ايليت بودي هوم لعلاج فرط التعرق بالبوتوكس واستمتع برعاية متخصصة في منشأة طبية متطورة. يضمن فريقنا من الخبراء المتخصصين في علاجات البوتوكس نتائج آمنة وفعالة تدوم لمدة طويلة، بجانب توفير خطط علاج شخصية مصممة خصيصًا وفقًا لاحتياجاتك الفردية. استمتع بحياة خالية من التعرق واستعد ثقتك بنفسك مع ايليت بودي هوم.",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة متكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم نتائج علاج فرط التعرق بالبوتوكس؟",
                    "answer": "تدوم النتائج ما بين 4 إلى 6 أشهر، ويُوصى بجلسات متابعة بعد ذلك للحفاظ على الفعالية."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "يشعر أغلب المرضى بانزعاج طفيف فقط، ويمكن استخدام مخدر موضعي لزيادة الراحة أثناء الإجراء."
                },
                {
                    "question": "متى تظهر نتائج العلاج؟",
                    "answer": "تبدأ النتائج بالظهور خلال 2 إلى 7 أيام، وتصل إلى أقصى فعاليتها خلال أسبوعين من العلاج."
                },
                {
                    "question": "هل يمكنني العودة إلى العمل بعد العلاج؟",
                    "answer": "نعم، لا يتطلب العلاج فترة تعافي، ويمكنك استئناف أنشطتك اليومية فورًا بعد الجلسة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};